export default __webpack_public_path__ + "static/banner8-314cba15b19fa1a5bd39b542b90eccbf.png";